// ─── Aide present at the visit ───────────────────────────
//
// Whether the home health aide (HHA/PCA) was actually THERE, as the nurse
// recorded it on the visit's Supervisory Evaluation form. Not the aide presence
// REQUIREMENT (agency setting / visit override, resolveAidePresenceRequired on
// the API) — a visit can require the aide and still find her absent.
//
// Only the supervisory form counts. SOC / reassessment visits also ask it in
// Visit Info (question 202) near the start, but the two answers disagree on
// ~6.5% of visits (the aide arrives late or leaves early), and only the
// supervisory answer is backed by the aide's signature. A visit without the form
// (most special visits, legacy imports, an unanswered form) has no value at all,
// and every surface shows nothing for it.
function oneLine(value) {
    return value.replace(/\s+/g, " ").trim();
}
/** "Yes" / "No"; "" when the visit has no supervisory answer. */
export function aidePresentYesNo(value) {
    if (!value) {
        return "";
    }
    return value.present ? "Yes" : "No";
}
/**
 * The absence reasons, then the note: "Already left: her shift had ended".
 * Empty when the aide was present — a handful of forms keep reason text from
 * before the nurse switched the answer to Yes, and it no longer applies.
 */
export function aidePresentNotes(value) {
    if (!value || value.present) {
        return "";
    }
    const reasons = value.reasonTags.map(oneLine).filter(Boolean).join(", ");
    const note = oneLine(value.note ?? "");
    if (reasons && note) {
        return `${reasons}: ${note}`;
    }
    return reasons || note;
}
/** Drawer text: "Yes", "No", or "No (Already left: …)". null = show no row. */
export function aidePresentLabel(value) {
    if (!value) {
        return null;
    }
    const notes = aidePresentNotes(value);
    return notes ? `${aidePresentYesNo(value)} (${notes})` : aidePresentYesNo(value);
}
//# sourceMappingURL=aide-present.js.map